import { defaultDateTimeFormatter, TableField } from "@/types/table-field";

const id: TableField = {
  key: "idVisualizacao",
  label: "ID",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const nome: TableField = {
  key: "nomeUsuario",
  label: "Usuário",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  sortable: true,
};
const ug: TableField = {
  key: "unidadeGestora",
  label: "Unidade Gestora",
  tdClass: ["align-middle", "quebrarPorPalavra", "text-left", "text-xl-center"],
  thClass: ["text-center", "quebrarPorPalavra"],
  thStyle: { minWidth: "110px" },
  sortable: true,
};
const data: TableField = {
  key: "dataVisualizacao",
  label: "Visto em",
  tdClass: ["align-middle", "naoQuebrar", "text-left", "text-xl-center"],
  thClass: ["text-center", "naoQuebrar"],
  thStyle: { minWidth: "90px" },
  formatter: defaultDateTimeFormatter,
  sortable: true,
};

export const fieldsVisualizacoes: TableField[] = [id, nome, ug, data];
